import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import axiosInstance from "../../Components/api/axiosInstance";
import { toast } from "react-toastify";

export const weatherData = createAsyncThunk("weather", async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/weather/weather-forecast",
      payload,
    );
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
});
const weatherSlice = createSlice({
  name: "weather",
  initialState: {
    weather: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(weatherData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(weatherData.fulfilled, (state, action) => {
        state.loading = false;
        state.weather = action.payload;
      })
      .addCase(weatherData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default weatherSlice.reducer;
